import { render, staticRenderFns } from "./ThankYouPage.vue?vue&type=template&id=6030afc8&"
import script from "./ThankYouPage.vue?vue&type=script&lang=js&"
export * from "./ThankYouPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports